<template>
  <div>
    <section class="container-fluid p-0 bodyArea">
      <div class="containerBox">
        <div class="pageHeader row m-0 align-items-center" v-if="$auth.isAuthenticated">
          <div class="col-3 pageHeaderTitle" @myEvent="fetchTenants">
            Devices Messages
          </div>
          <div class="col p-0 text-right">
            <div class="filterWrapper">
              <div class="filterText">Tenant:</div>
              <div class="dropdown col p-0">
                <model-select v-model="lastSelectedTenantObj" :options="tenants" name="tenantLableName" id="tenantLableId"
                              placeholder="Select Tenant" @input="validateSelection" class="tenantsList">
                </model-select>
              </div>
            </div>
            <div class="importBtn" @click.prevent="addMessage">Add Message</div>
          </div>
        </div>
        <div class="pageDataWrapper">

          <div class="contentHeader row m-0 align-items-center">
            <div class="col">Label</div>
            <div class="col">Text</div>
            <div class="col">Translated Label</div>
            <div class="col">Delay</div>
            <div class="col">Type</div>
            <div class="col">Repeat Count</div>
            <div class="col">Play Alert Sound</div>
            <div class="col">Language Settings</div>
          </div>

          <div v-if="list.length > 0" class="contentDataWrap">
            <div v-for="(item, index) in list" :key="index">
              <div class="actions contentActualDataWrapper row m-0" variant="primary">
                <div class="contentData row m-0 align-items-center col-12 p-0">
                  <div class="col">{{ item.label }}</div>
                  <div class="col">{{  item.text }}</div>
                  <div class="col">
                    {{
                      item.languages.length > 0
                        ? returnSelectedTXT(item.languages)
                        : "No Languages added"
                    }}
                  </div>
                  <div class="col">
                    {{ item.delay }}
                  </div>
                  <div class="col">{{ item.type }}</div>
                  <div class="col">{{ item.repeatCount }}</div>
                  <div class="col">{{ item.playAlertSound == true ? "true" : "false" }}</div>
                  <div class="col">
                    <div class="add-Btn flex-8" style="padding-right: 10px">
                      <b-button v-if="item.languages.length > 0" class="actionBtn clientShowBtn"
                                @click="toggleCollapse(index)" title="Show language settings">Show
                      </b-button>
                      <b-button v-if="item.languages.length == 0" class="actionBtn clientShowBtn"
                                @click="addLanguage(index)" title="Add language">Add
                      </b-button>
                      <b-button class="actionBtn clientShowBtn" @click="editDeviceMessage(index, item)"
                                title="Edit device message" style="margin-left: 10px"> Edit
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>

              <b-collapse :id="'collapse-' + index" class="mt-2" :visible="isCollapseOpen(index)"
                          v-if="item.languages.length > 0">
                <b-card>
                  <div class="contentHeader row m-0 align-items-center">
                    <div class="col">Selection</div>
                    <div class="col">language (lbl)</div>
                    <div class="col">Translated content (txt)</div>

                    <div class="col">language Code (cd)</div>
                    <div class="col">
                      Actions
                      <b-button class="addbtn" style="margin-left: 100px" @click="addLanguage(index)">
                        <img src="../assets/images/add.svg" width="16" />
                      </b-button>
                    </div>
                  </div>
                  <div v-for="lang in item.languages">
                    <div class="actions contentActualDataWrapper row m-0">
                      <div class="col">
                        <input type="checkbox" v-model="lang.isChecked" @change="handleCheckboxChange(lang, index)" />
                      </div>
                      <div class="col">{{ lang.lbl }}</div>
                      <div class="col">{{ lang.txt }}</div>
                      <div class="col">
                        {{ lang.cd }}
                      </div>
                      <div class="col flex-6">
                        <span class="add-Btn" @click="editLanguage(index, lang)" title="Edit" style="padding-right: 10px">
                          <img src="../assets/images/edit.svg" width="16" />
                        </span>
                        <span class="add-Btn" title="Delete" @click="deleteLanguage(index, lang)"
                              style="padding-right: 10px">
                          <img src="../assets/images/delete.svg" width="16" />
                        </span>
                      </div>
                    </div>
                  </div>
                </b-card>
              </b-collapse>
            </div>
          </div>

          <div v-if="listEmpty == true">
            <h3>No results found</h3>
          </div>
        </div>
      </div>
      <b-modal ref="my-modal" id="addModal" hide-backdrop centered v-bind:title="title" title-class="test" ok-title="Save"
               @ok="validateLanguage" @hidden="addModal" @cancel="addModal">
        <b-form ref="form">
          <!-- <b-form-group label="Language Code (cd)" label-for="cd" invalid-feedback="Please enter Language Code.">
            <b-form-input :disabled="isEdit" id="cd" v-model="cd" placeholder="Language Code (like en-US)"
              :class="!validations.cd ? 'in-valid' : 'valid'"></b-form-input>
          </b-form-group> -->

          <b-form-group label=" Language Label" label-for="lbl" invalid-feedback="Please select Language.">
            <!-- <b-form-input id="lbl" v-model="lbl" placeholder="Language label (like Spanish (Mexico))"
              :class="!validations.lbl ? 'in-valid' : 'valid'"></b-form-input> -->
            <b-form-select :disabled="isEdit" id="lbl" class="languageWrapperSelect" v-model="selectedLanguage"
                           style="width: 50%">
              <option class="w-75" v-for="option in languages" v-bind:key="option.name" :value="option"
                      :disabled="option.disabled">
                {{ option.name + "(" + option.code + ")" }}
              </option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Language Text (txt)" label-for="Language" invalid-feedback="Please enter Language Text.">
            <b-form-input id="txt" v-model="txt" placeholder="Language Text"
                          :class="!validations.txt ? 'in-valid' : 'valid'"></b-form-input>
          </b-form-group>
          <b-form-group label="Record Audio for Language text to be played on Device" label-for="Record_Audio"
                        invalid-feedback="Please enter Language Text.">
            <!-- <span class="audio_note">Note: Please use a headset with microphone to record the
              audio</span><br />
            <b-button class="actionBtn" title="Record audio" @click="checkForAudioStream()"
              v-bind:disabled="audioStreamEnabled">{{ enableDisableAudioStream }} </b-button>&nbsp;
            <b-button v-if="startRecording === 0 || startRecording === 2" class="actionBtn" title="Record audio"
              @click="recordAudioForText()" v-bind:disabled="!audioStreamEnabled"><img
                src="../assets/images/icons8-add-record-50.png" width="16" />
              {{ audioRecordingText }}
            </b-button>
            <b-button v-if="startRecording === 1" class="actionBtn" title="Record audio"
              @click="recordAudioForText()"><img src="../assets/images/icons8-stop-64.png" width="16" />
              Stop audio recording
            </b-button>
            &nbsp; -->
            <b-button class="actionBtn" title="Upload text file" @click=""><img src="../assets/images/text-to-speech.png"
                                                                                width="16" />
              Text to speech
            </b-button>&nbsp;
            <b-button class="actionBtn" title="Play audio" @click="uploadAudioFile()"><img
              src="../assets/images/icons8-upload-24.png" width="16" />
              Upload audio file
            </b-button>
            <div id="audioFiles" ref="audioFiles">
              <div v-if="isEdit">
                <audio controls v-bind:src="audioInBase64"></audio>
              </div>
            </div>
            <p v-if="uploadError && uploadError.length > 0" class="upload-err">{{ uploadError }}</p>
            <input type="file" hidden style="display: none" id="audioFilesToUpload" @change="handleFiles"
                   accept="audio/*" />

          </b-form-group>
        </b-form>
      </b-modal>
      <!-- device messages model starts here  -->
      <b-modal ref="my-modal" id="addDeviceMessagesModal" hide-backdrop centered v-bind:title="deviceMessageTitle"
               title-class="test" ok-title="Save" :ok-disabled="disableSaveDevicemessage()" @ok="saveDevicemessages"
               @hidden="clearDeviceMessagesModal" @cancel="clearDeviceMessagesModal">
        <b-form ref="form">
          <!-- type start typeOptions-->
          <b-form-group label="Type" label-for="type" invalid-feedback="Please select type option.">
            <b-form-select id="default" class="languageWrapperSelect" v-model="deviceDefaultMessages.type"
                           style="width: 50%">
              <option class="w-75" v-for="option in typeOptions" v-bind:key="option.text" :value="option.value">
                {{ option.text }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Label" label-for="devicemessages-label">
            <b-form-input id="devicemessages-label" v-model="deviceDefaultMessages.label"></b-form-input>
            <p v-if="(deviceDefaultMessages.label === null || deviceDefaultMessages.label === '')" style="color: red">Please
              enter a valid
              length of meaningful text.</p>
          </b-form-group>
          <b-form-group label="Text " label-for="text">
            <b-form-input id="text" v-model="deviceDefaultMessages.text"></b-form-input>
            <p v-if="(deviceDefaultMessages.text === null || deviceDefaultMessages.text === '')" style="color: red">Please
              enter a valid
              length of meaningful text.</p>
          </b-form-group>

          <!-- type end-->

          <b-form-group label="Delay in milli seconds" label-for="delay">
            <b-form-input id="delay" v-model="deviceDefaultMessages.delay"></b-form-input>
            <p v-if="validateDelayInput() && deviceDefaultMessages.delay > 10000" style="color: red">
              The input should be a number and less than 10000.</p>
              <p v-if="validateDelayInput() && deviceDefaultMessages.delay < 5000" style="color: red">
                The input should be a number and greater than 5000.</p>
          </b-form-group>
          <!-- repeatCount -->
          <b-form-group label="Repeat Count" label-for="repeatCount">
            <b-form-input id="repeatCount" v-model="deviceDefaultMessages.repeatCount" ></b-form-input>
            <p v-if="validateRepeatCountInput()"
               style="color: red">The input should be a number and less than 10000.</p>
          </b-form-group>
          <b-form-group label="Play Alert sound" label-for="playAlertSound" class="play-checkbox">
            <b-form-checkbox id="playAlertSound" v-model="deviceDefaultMessages.playAlertSound"></b-form-checkbox>
          </b-form-group>
        </b-form>
      </b-modal>

      <!-- device messages model ends here  -->


      <!-- delete model -->
      <div v-if="showDeleteModal == true">
        <div class="areYouSureWrapper row m-0 align-items-center">
          <div class="popUpContent">
            <div class="popupHead">
              <span aria-hidden="true" @click="showDeleteModal = false">&times;</span>
            </div>
            <div class="popupBody">
              Are you sure you want to delete language?
            </div>
            <div class="popupFooter">
              <div class="yesBtn btn" @click.prevent="deleteLanguageConfirm($event)">
                Yes
              </div>
              <div class="noBtn btn" @click="showDeleteModal = false">No</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import Datepicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Dropdown from "vue-simple-search-dropdown";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import languagesJson from "../assets/languages.json";
import cloneDeep from 'lodash/cloneDeep';


const RECORDING_STATE = {
  NO_RECORDING: 0,
  START_RECORDING: 1,
  STOP_RECORDING: 2
};

Vue.use(VueToast);
export default {
  name: "ReleaseNotes",
  components: {
    Datepicker,
    Dropdown,
    ModelSelect
  },
  data() {
    return {
      //validating fields
      validations: {
        cd: true,
        lbl: true,
        txt: true,
        audioInBase64: false
      },
      list: [],
      tenantsList: [],
      value: "",
      dateValue: "",
      lastSelectedTenant: "",
      tenants: [{ text: "-SELECT ALL-", value: "*" }],
      listEmpty: false,
      openCollapseIndex: null, // Track the index of the open b-collapse
      cd: "",
      lbl: "",
      txt: "",
      audioInBase64: "",
      selectedIndex: null,
      isEdit: false,
      showDeleteModal: false,
      title: "Add Language",
      deviceMessageTitle: "Add New Device Message",
      audioRecordingText: "Start audio recording",
      startRecording: RECORDING_STATE.NO_RECORDING,
      audioStreamEnabled: false,
      recorder: null,
      audioChuncks: null,
      enableDisableAudioStream: "Enable audio stream to record",
      languages: languagesJson,
      selectedLanguage: null,
      uploadError: "",
      isDeviceMessageEdit: false,
      deviceDefaultMessages: {},
      lastSelectedTenantObj: "",
      defaultTrueFalseOptions: [{
        value: true,
        text: "True"
      }, {
        value: false,
        text: "False"
      }
      ],
      typeOptions: [{
        value: "alert",
        text: "Alert"
      }],
      editSelectedDeviceMessageIndex: null,
      editSelectedDeviceMessage: {},
      disableDelay:true,
      disableRepeatCount:true

    };
  },
  mounted() {
    this.selectedLanguage = this.languages[0];
    this.fetchData();
    this.fetchTenants();
    $("input").attr("autocomplete", "off");
  },
  async created() {
    setTimeout(
      function() {
        this.fetchTenants();
      }.bind(this),
      1000
    );
    const sortedLanguages = [
      ...languagesJson.filter(item => item.name === "-Select language-"),
      ...languagesJson
        .filter(item => item.name !== "-Select language-")
        .sort((a, b) => a.name.localeCompare(b.name))
    ];

    this.languages = sortedLanguages;
  },
  methods: {
    getDropdownValues(tenant) {
      return this.tenantsList.filter((e) => e.id == tenant || e.name == tenant);
    },
    getTenantId(Obj) {
      let objVal = this.tenants.find(e => e.value == Obj);
      if (objVal) {
        return objVal.id;
      } else {
        return "";
      }
    },
    validateSelection() {
      this.lastSelectedTenant = this.getTenantId(this.lastSelectedTenantObj);
      // this.lastSelectedTenant = selection;
      this.fetchData();
    },

    //add messages for the selected tenent 
    async addMessage() {
      if (this.lastSelectedTenant) {
        this.deviceMessageTitle = "Add New Device Message";
        this.deviceDefaultMessages={}
        this.$bvModal.show("addDeviceMessagesModal");
      } else {
        Vue.$toast.open({ message: "Please select tenant.", type: "error" });
      }
    },
    validateDelayInput(){
      if (this.isNumeric(this.deviceDefaultMessages.delay) && (this.deviceDefaultMessages.delay <= 10000) && (this.deviceDefaultMessages.delay >= 5000)) {
        
        this.disableDelay= false;
        return false;
      } else {
       
        this.disableDelay = true;
        return true;
      }
    },
    validateRepeatCountInput(){
      if (this.isNumeric(this.deviceDefaultMessages.repeatCount) && (this.deviceDefaultMessages.repeatCount <= 10000)) {
        
        this.disableRepeatCount = false;
        return false;
      } else {
       
        this.disableRepeatCount = true;
        return true;
      }
    },
    //opening and doing the nessary data preparation here
    editDeviceMessage(selectedDeviceMessageIndex, selectedDeviceMessage) {
      this.isDeviceMessageEdit = true;
      this.editSelectedDeviceMessageIndex = selectedDeviceMessageIndex;
      this.editSelectedDeviceMessage = selectedDeviceMessage;
      this.deviceDefaultMessages = cloneDeep(selectedDeviceMessage);
      this.deviceDefaultMessages["active"] = this.deviceDefaultMessages.active ? this.deviceDefaultMessages.active : true;
      this.deviceDefaultMessages["default"] = this.deviceDefaultMessages.default ? this.deviceDefaultMessages.default : false;
      this.deviceMessageTitle = "Update Device Message";
      this.$bvModal.show("addDeviceMessagesModal");
    },
    async saveDevicemessages() {
      this.deviceDefaultMessages.delay = Number(this.deviceDefaultMessages.delay);
      this.deviceDefaultMessages.playAlertSound = this.deviceDefaultMessages.playAlertSound;
      this.deviceDefaultMessages.repeatCount = Number(this.deviceDefaultMessages.repeatCount);
      //save Post call for edit and non edit activities
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      if (this.isDeviceMessageEdit === false) {
        this.deviceDefaultMessages.languages = [];
        this.list.push(this.deviceDefaultMessages);
        //for localhost checking
        // var url = `http://localhost:8080/tenants/${this.lastSelectedTenant}/device-message`;
        var url =
          config.OPERATIONS_SERVICE +
          `/tenants/${this.lastSelectedTenant}/device-message`;
        var save_device_message = new Request(url, {
          method: "POST",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          body: JSON.stringify(this.deviceDefaultMessages),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        });
        try {
          var response = await fetch(save_device_message);
          Vue.$toast.open({
            message: "Device message added successfully.",
            type: "success"
          });

        } catch (err) {
          console.error("Failed to add the device message.", err);
          Vue.$toast.open({
            message: "Failed to add the device message.",
            type: "error"
          });
        } finally {
          //reset and re fetch the updated information
          this.fetchData();
          this.$bvModal.hide("addDeviceMessagesModal");
          this.deviceDefaultMessages = {};
        }
      } else {
        //edit time logic needs to implement from here
        if (this.list[this.editSelectedDeviceMessageIndex].id === this.deviceDefaultMessages.id) {      
          this.list[this.editSelectedDeviceMessageIndex] = this.deviceDefaultMessages;
          //for localhost checking
          // var url = `http://localhost:8080/tenants/${this.lastSelectedTenant}/device-message/${this.list[this.editSelectedDeviceMessageIndex].id}`;
          var url =
            config.OPERATIONS_SERVICE +
            `/tenants/${this.lastSelectedTenant}/device-message/${this.list[this.editSelectedDeviceMessageIndex].id}`;
          var update_device_message = new Request(url, {
            method: "PATCH",
            mode: "cors",
            withCredentials: true,
            credentials: "include",
            body: JSON.stringify(this.deviceDefaultMessages),
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json"
            }
          });
          try {
            var response = await fetch(update_device_message);

            Vue.$toast.open({
              message: "Device message updated successfully.",
              type: "success"
            });

          } catch (err) {
            console.error("Failed to update the device message.", err);
            Vue.$toast.open({
              message: "Failed to update the device message.",
              type: "error"
            });
          } finally {
            //reset and re-fetch the updated information
            this.fetchData();
            this.$bvModal.hide("addDeviceMessagesModal");
            this.deviceDefaultMessages = {};
            this.selectedDeviceMessageIndex = null;
            this.selectedDeviceMessage = {};
          }
        }
      }
    },

    //method for the fetching the available tenant's list for the selection
    async fetchTenants() {
      this.tenants = [];
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.TENET_SERVICE + "/tenants/?list=true",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        }
      );
      if (tenants_list_request.status == 503) {
        return this.fetchTenants();
      }
      try {
        var tenants_list = await fetch(tenants_list_request);
        var response = await tenants_list.json();
        this.tenants = response
          .map((t) => {
            return {
              text: t.text || t.value,
              id: t.value,
              value: t.value.toLowerCase().replace("-", "")
            };
          })
          .sort((a, b) => {
            return a.text.localeCompare(b.text);
          });
        this.tenants.forEach((e) =>
          this.tenantsList.push({ id: e.value, name: e.text || e.value })
        );
      } catch (error) {
        console.error(error);
      }
    },
    //method for the fetching the device's messages list for the selection
    async fetchData() {
      if (this.lastSelectedTenant) {
        this.listEmpty = false;
        this.list = [];
        let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        //for localhost checking
        // var Url = `http://localhost:8080/tenants/${this.lastSelectedTenant}/device-messages?limit=100&offset=0`;
        var Url =
          config.OPERATIONS_SERVICE +
          `/tenants/${this.lastSelectedTenant}/device-messages?limit=100&offset=0`;
        try {
          const res = await fetch(Url, {
            method: "GET",
            mode: "cors",
            withCredentials: true,
            cache: "default",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json"
            }
          });
          if (res.status === 503) {
            return this.fetchData();
          } else {
            const newRes = await res.json();

            this.list = newRes.deviceMessages;
            if (this.list.length == 0) {
              this.listEmpty = true;
              loader.hide();
            } else if (this.list.length > 0) {
              this.listEmpty = false;
              loader.hide();
            }
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    //method to handle the open and collapse activities in view
    toggleCollapse(index) {
      // Toggle the b-collapse for the clicked item
      if (this.openCollapseIndex === index) {
        this.openCollapseIndex = null; // Close if already open
      } else {
        this.openCollapseIndex = index; // Open the clicked one
      }
    },
    isCollapseOpen(index) {
      // Check if the b-collapse at the specified index is open
      return this.openCollapseIndex === index;
    },
    //on close and cancel call time model destroyer
    clearDeviceMessagesModal() {
      this.addDeviceMessagesModal = {};
      this.deviceMassageTitle = "Add Device Message";
      this.$bvModal.hide("addDeviceMessagesModal");
      this.isDeviceMessageEdit = false;
    },
    //preparing the device message model
    addDeviceMessagesModal() {
      if (this.lastSelectedTenant) {
        this.addDeviceMessagesModal = {};
        this.deviceDefaultMessages["tenant"] = this.lastSelectedTenant;
        this.deviceDefaultMessages["active"] = true;
        this.deviceDefaultMessages["default"] = false;
        this.deviceMassageTitle = "Add Device Message";
        this.$bvModal.hide("addDeviceMessagesModal");
        this.isDeviceMessageEdit = false;
      } else {
        Vue.$toast.open({ message: "Please select tenant.", type: "error" });
      }
    },

    //method for the checking the numbr values 
    isNumeric(value) {
      return /^[+]?\d+(\.\d+)?$/.test(value);
    },
    disableSaveDevicemessage() {
      if (this.deviceDefaultMessages.tenant !== null &&
        this.deviceDefaultMessages.repeatCount !== null &&
        this.deviceDefaultMessages.playAlertSound !== null &&

        this.deviceDefaultMessages.delay !== null &&

        this.deviceDefaultMessages.text !== null &&

        this.deviceDefaultMessages.type !== null &&

        this.deviceDefaultMessages.default !== null &&

        this.deviceDefaultMessages.active !== null && !this.disableDelay && !this.disableRepeatCount) {
        return false;

      } else {
        return true;
      }
    },
    //On cancel or close icon handilings to reset the basic form fields from here
    addModal() {
      this.cd = "";
      this.txt = "";
      this.lbl = "";
      this.title = "Add Language";
      this.$bvModal.hide("addModal");
      this.isEdit = false;
    },
    //method to show the add model and prepare the languge object fields for the form
    addLanguage(index) {
      this.selectedLanguage = this.languages[0];
      this.startRecording = RECORDING_STATE.NO_RECORDING;
      this.validations.audioInBase64 = false;
      this.audioRecordingText = "Start audio recording";
      this.selectedIndex = index;
      this.title = "Add Language";
      this.$bvModal.show("addModal");
    },
    async validateLanguage(e) {
      if (this.selectedLanguage) {
        this.cd = this.selectedLanguage ? this.selectedLanguage.code : "";
        this.lbl = this.selectedLanguage ? this.selectedLanguage.name : "";
      }
      e.preventDefault();
      this.validations.cd = this.cd && this.cd.trim() !== "" ? true : false;
      this.validations.txt = this.txt && this.txt.trim() !== "" ? true : false;
      this.validations.lbl = this.lbl && this.lbl.trim() !== "" ? true : false;
      if (this.validations.cd && this.validations.txt && this.validations.lbl) {
        this.saveAndUpdateLanguage();
      } else {
        return false;
      }
    },
    checkForAudioStream() {
      if (!this.audioStreamEnabled) {
        navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
          this.audioStreamEnabled = true;
          this.recorder = new MediaRecorder(stream);
          this.recorder.ondataavailable = (e) => {
            this.validations.audioInBase64 = true;
            this.audioChuncks.push(e.data);
            if (this.recorder.state === "inactive") {
              let blob = new Blob(this.audioChuncks, { type: "audio/ogg" });
              let audioStreamData = new FileReader();
              audioStreamData.onloadend = () => {
                this.audioInBase64 = audioStreamData.result;
                this.audioInBase64 = this.audioInBase64.split(",")[1];

                let audioElem = new Audio(
                  "data:audio/wav;base64," + this.audioInBase64
                );
                audioElem.controls = true;
                document.getElementById("audioFiles").appendChild(audioElem);
              };
              audioStreamData.readAsDataURL(blob);
            }
          };
        });
      } else {
        this.enableDisableAudioStream = "Disable Audio stream";
      }
    },
    handleFiles(event) {
      if (window.FileReader) {
        const fileToUpload = event.target.files[0];
        if (fileToUpload) {
          let totalBytes = fileToUpload.size;
          if (totalBytes < 1000000) {
            let _size = Math.floor(totalBytes / 1000); // it results the size in KB's'
            if (_size <= 10) {
              var reader = new FileReader();
              reader.onload = (e) => {
                this.audioInBase64 = e.target.result;
                this.audioInBase64 = this.audioInBase64.split(",")[1];

                let audioElem = new Audio(
                  "data:audio/wav;base64," + this.audioInBase64
                );
                audioElem.controls = true;
                document.getElementById("audioFiles").appendChild(audioElem);
              };
              reader.onerror = (evt) => {
                if (evt.target.error.name == "NotReadableError") {
                  // this.importLoadingMessage = "ERROR reading file";
                  Vue.$toast.open({ message: "ERROR reading file", type: "error" });
                  this.importedUsers = null;

                  // alert("Cannot read file !");
                  Vue.$toast.open({ message: "Cannot read file !", type: "error" });
                }
              };
              reader.readAsDataURL(fileToUpload);
            } else {
              this.uploadError = "Audio file size is too big and not supported.";
              return false;
            }
          } else {
            this.uploadError = "Audio file size is too big and not supported.";
            return false;
          }
        }
      }
    },
    async recordAudioForText() {
      if (this.startRecording === RECORDING_STATE.NO_RECORDING) {
        this.validations.audioInBase64 = false;
        this.startRecording = RECORDING_STATE.START_RECORDING;
        this.startAudioRecording();
      } else if (this.startRecording === RECORDING_STATE.STOP_RECORDING) {
        this.validations.audioInBase64 = false;
        this.startRecording = RECORDING_STATE.START_RECORDING;
        this.startAudioRecording();
      } else {
        // STOP Recording
        this.validations.audioInBase64 = true;
        this.stopAudioRecording();
        this.startRecording = RECORDING_STATE.STOP_RECORDING;
        this.audioRecordingText = "Reset & Start audio recording";
        this.validations.audioInBase64 = !this.validations.audioInBase64;
      }
    },
    startAudioRecording() {
      this.audioChuncks = [];
      this.recorder.start();
      document.getElementById("audioFiles").innerHTML = "";
    },
    stopAudioRecording() {
      this.recorder.stop();
    },
    async uploadAudioFile() {
      document.getElementById("audioFilesToUpload").click();
    },

    //method for handing the edit/add activities of the languges of the deviceMessages
    async saveAndUpdateLanguage() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      if (this.isEdit === false) {
        let languageObj = {
          cd: this.cd,
          lbl: this.lbl,
          txt: this.txt,
          isChecked: false,
          audioInBase64: this.audioInBase64
        };
        this.list[this.selectedIndex].languages.push(languageObj);
        //for localhost checking
        // var url = `http://localhost:8080/tenants/${this.lastSelectedTenant}/device-message-languages`;
        var url =
          config.OPERATIONS_SERVICE +
          `/tenants/${this.lastSelectedTenant}/device-message-languages`;
        var save_language = new Request(url, {
          method: "POST",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          body: JSON.stringify({
            id: this.list[this.selectedIndex].id,
            tenant: this.lastSelectedTenant,
            languages: this.list[this.selectedIndex].languages
          }),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        });
        try {
          var response = await fetch(save_language);
          this.$bvModal.hide("addModal");
          this.cd = "";
          this.lbl = "";
          this.txt = "";
          Vue.$toast.open({
            message: "Languge added successfully.",
            type: "success"
          });
        } catch (err) {
          console.error("Failed to add the language.", err);
          Vue.$toast.open({
            message: "Failed to add the language.",
            type: "error"
          });
        }
      } else {
        let languageMatchIndex = this.list[
          this.selectedIndex
          ].languages.findIndex(
          (x) => x.cd === this.cd && x.lbl === this.lbl && x.txt === this.txt
        );
        if (languageMatchIndex != -1) {
          this.list[this.selectedIndex].languages[languageMatchIndex].txt =
            this.txt;
          this.list[this.selectedIndex].languages[languageMatchIndex].lbl =
            this.lbl;
          this.list[this.selectedIndex].languages[
            languageMatchIndex
            ].audioInBase64 = this.audioInBase64;
        }
        //for localghost checking
        // var url = `http://localhost:8080/tenants/${this.lastSelectedTenant}/device-message-languages`;
        var url =
          config.OPERATIONS_SERVICE +
          `/tenants/${this.lastSelectedTenant}/device-message-languages`;
        var update_language = new Request(url, {
          method: "POST",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          body: JSON.stringify({
            id: this.list[this.selectedIndex].id,
            tenant: this.lastSelectedTenant,
            languages: this.list[this.selectedIndex].languages
          }),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        });
        try {
          var response = await fetch(update_language);
          this.$bvModal.hide("addModal");
          this.cd = "";
          this.lbl = "";
          this.txt = "";
          this.isEdit = false;
          Vue.$toast.open({
            message: "Languge Updated successfully.",
            type: "success"
          });
        } catch (err) {
          Vue.$toast.open({
            message: "Failed to complete the language update.",
            type: "error"
          });
          console.error("Failed to update language.", err);
        }
      }
    },
    //method for invoking the delete confirmation popup
    deleteLanguage(index, selectedLanguage) {
      this.selectedIndex = index;
      this.selectedLanguage = selectedLanguage;
      this.showDeleteModal = true;
    },
    //method to hit API and delete the language from the DB on the success responce
    async deleteLanguageConfirm(event) {
      //api call need to hit from here
      this.selectedIndex;
      this.selectedLanguage;
      // prepare object by removing the selected language
      // this.list[this.selectedIndex].languages = this.list[
      //   this.selectedIndex
      // ].languages.filter(
      //   (x) =>
      //     x.cd !== this.selectedLanguage.cd &&
      //     x.lbl !== this.selectedLanguage.lbl &&
      //     x.txt !== this.selectedLanguage.txt
      // );
      const indexOfLangToDelete = this.list[
        this.selectedIndex
        ].languages.findIndex(
        (l) =>
          l.cd === this.selectedLanguage.cd &&
          l.txt === this.selectedLanguage.txt &&
          l.lbl === this.selectedLanguage.lbl
      );
      if (indexOfLangToDelete !== -1) {
        this.list[this.selectedIndex].languages.splice(indexOfLangToDelete, 1);
      }
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.OPERATIONS_SERVICE +
        `/tenants/${this.lastSelectedTenant}/device-message-languages`;
      //for localhost based checking
      // var url = `http://localhost:8080/tenants/${this.lastSelectedTenant}/device-message-languages`;
      var update_language = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        body: JSON.stringify({
          id: this.list[this.selectedIndex].id,
          tenant: this.lastSelectedTenant,
          languages: this.list[this.selectedIndex].languages
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(update_language);
        this.showDeleteModal = false;
        Vue.$toast.open({
          message: "Languge deleted successfully.",
          type: "success"
        });
      } catch (err) {
        Vue.$toast.open({
          message: "Failed to Delete language.",
          type: "error"
        });
        console.error("Failed to Delete language.", err);
      }
    },
    //method for preparing the edit object and required variables while editing the language
    editLanguage(index, selectedLanguage) {
      this.selectedLanguage = { name: selectedLanguage.lbl, code: selectedLanguage.cd };
      this.isEdit = true;
      this.lbl = selectedLanguage.lbl;
      this.cd = selectedLanguage.cd;
      this.txt = selectedLanguage.txt;
      this.audioInBase64 = selectedLanguage.audioInBase64
        ? "data:audio/wav;base64," + selectedLanguage.audioInBase64
        : undefined;
      this.selectedIndex = index;
      this.title = "Edit Language";
      this.$bvModal.show("addModal");
    },
    //handelr for the updating the checkboxes based onthe selection
    handleCheckboxChange(selectedLang, selectedIndex) {
      this.selectedIndex = selectedIndex;
      const updatedData = this.list[selectedIndex].languages.reduce(
        (accumulator, currentItem) => {
          if (currentItem.cd === selectedLang.cd) {
            // Update the object as needed
            if (currentItem.isChecked === true) {
              const updatedItem = { ...currentItem, isChecked: false };
              accumulator.push(updatedItem);
            } else {
              const updatedItem = { ...currentItem, isChecked: true };
              accumulator.push(updatedItem);
            }
          } else {
            // Keep the other objects get false/unchecked
            const updatedItem = { ...currentItem, isChecked: false };
            accumulator.push(updatedItem);
          }
          return accumulator;
        },
        []
      );
      this.list[selectedIndex].languages = updatedData;
      //here we need to call edit kind of save call for updating the selection in backend
      this.cd = selectedLang.cd;
      this.lbl = selectedLang.lbl;
      this.txt = selectedLang.txt;
      this.isEdit = true;
      this.saveAndUpdateLanguage();
    },
    //Projecting the selected language TXT for view
    returnSelectedTXT(selectedLanguageObj) {
      let checkedIndex = selectedLanguageObj.findIndex(
        (a) => a.isChecked === true
      );
      if (checkedIndex != -1) {
        return selectedLanguageObj[checkedIndex].txt;
      } else {
        return "No Languages Selected.";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../style.scss";

::v-deep .ui.search.dropdown .text {
  max-width: 230px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #fff;
  height: 15px;
}

.device-messages-navBar {
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
}

.ui.selection.dropdown {
  border: none !important;

  i.dropdown.icon {
    display: none;
  }
}


.pageHeader {
  font-family: GTWalsheimPro-Regular !important;
  font-size: 15px;
  font-weight: 400;
}

.pageActualDataWrapper {
  max-height: 100%;
}

.contentDataWrapper {
  font-family: GTWalsheimPro-Regular !important;

  font-size: 16px;
  //overflow-y: auto;
  overflow-x: hidden;
  font-weight: 400;
}

.contentDataWrapper.actions {
  overflow: initial !important;
}

.contentDataWrapper.actions .contentData > div.dropdownAction {
  overflow: initial !important;
}

.contentDataWrap {
  // max-height: calc( 100vh - 160px );;
  //max-height: calc( 100vh - 100px );
  height: 100%;
  overflow-y: auto;
  padding-bottom: 20px;
}

.flex-10 {
  flex: 10 !important;
}

.contentHeader {
  font-family: GTWalsheimPro-Regular !important;
  font-size: 16px;
  overflow-x: hidden;
  font-weight: 400;
}

.filterWrapper {
  background: #575757;
    display: inline-flex;
    padding: 0px 10px;
    font-size: 16px;
    min-width: 360px;
    max-width: 360px;
    border-radius: 5px;
    margin-left: 15px;
    align-items: center;
    text-overflow: ellipsis;
}


.dropdown {
  cursor: pointer;
  background: transparent !important;
  border: 0px;
}

.filterText {
  color: #fff;
  opacity: 1;
  padding-right: 0px;
}

.tenantOption {
  color: #6a6a6a;
  padding: 10px;
}

.actionBtn.clientShowBtn.btn-secondary {
  border-radius: 5px;
  min-width: 80px;
  text-align: center !important;
  display: inline-grid;
  background: #1dd8f6;
  color: #fff;
  line-height: 36px;
  padding: 0 15px;
  cursor: pointer;
  font-size: 15px;
  border-color: #1dd8f6;
  width: auto;
}
.actionBtn.clientShowBtn.btn-secondary:hover{
  background: #3188D2 !important;
}

.filterWrapper .dropdown {
  width: 100%;
  text-align: left;
  cursor: pointer;
  background: transparent !important;
  height: auto;
  top: 0px;
}

.actionBtn.clientShowBtn.btn-secondary:hover {
  background: #1dd8f6;
  color: #ffffff;
  border-color: #1dd8f6;
}

.actionBtn:focus {
  background: #00b5da;
  color: #fff;
}

.col:first-child {
  border-right: 1px solid #c7c7c7;
  padding-right: 20px;
}

textarea.form-control {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border: 1px solid #dceaea;
  border-radius: 5px;
  width: 100%;
  padding: 7px 15px;
  color: #6a6a6a;
}

.text-right {
  text-align: right !important;
}

.addBtn {
  border: 1px solid #dceaea;
  border-radius: 5px;
  padding: 7px 15px;
  color: #6a6a6a;
  width: 90px;
  text-align: center;
}

.areYouSureWrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
}

.popUpContent {
  min-width: 350px;
  max-width: 350px;
  border-radius: 10px;
  background: #fff;
}

.popupHead {
  background: #00b5da;
  line-height: 40px;
  border-radius: 10px 10px 0 0;
  color: #fff;
  padding: 0 15px;
  height: 40px;
}

.popupHead span {
  float: right;
}

.popupBody {
  color: #6a6a6a;
  padding: 15px;
}

.filterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 0px;
  top: 15px;
}

.popupFooter {
  border-radius: 0px 0px 10px 10px;
  background: #f2fdff;
  color: #6a6a6a;
  padding: 15px;
  justify-content: center;
  text-align: center;
}

.yesBtn,
.noBtn {
  margin-right: 15px;
  border: 1px solid #dae1f2 !important;
  border-radius: 10px;
  padding: 5px 20px !important;
}

.noBtn {
  margin-left: 15px;
  margin-right: 0px;
}

.yesBtn:hover,
.noBtn:hover {
  background: #fff !important;
  color: #00b5da !important;
}

.modal-header {
  background: #50b9d4;
  color: #fff;
}

.btn {
  background: #50b9d4;
  color: #fff;
  border-color: #50b9d4;
  padding: 5px 10px;
  border: 0px;
}

.CheckbOXcontainer .checkmark:after {
  left: 5px;
  top: 2px;
  width: 3px;
  height: 7px;
  border: solid #ebebeb;
  border-width: 0 1px 1px 0;
  transform: rotate(45deg);
}

.checkmark {
  border: 1px solid #ebebeb;
  border-radius: 3px;
}

.add-Btn {
  cursor: pointer;
}

.in-valid {
  border-color: #dc1414 !important;
}

.valid {
  border-color: #fff !important;
}
input[type=text].valid{
  border-color: #dceaea !important;
}

.audio_note {
  font-family: GTWalsheimPro-Regular !important;
  font-size: 15px;
  font-style: oblique;
  font-palette: dark;
}

.importBtn {
  background: #575757;
  display: inline-flex;
  padding: 0px 15px;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 10px;
  width: auto;
  line-height: 38px;
  max-height: 38px
}

.importBtn:hover {
  color: #fff;
  cursor: pointer;
  background:#1dd8f6;
}

.upload-err {
  color: #dc1414 !important;
}

.languageWrapperSelect {
  width: 100% !important;
}

::v-deep .ui.selection.dropdown .menu .item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 334px;
  margin: 0px 10px 2px;
    padding: 10px 7px !important;
    border-radius: 5px;
    border: none;
}

.pageHeader  ::v-deep .ui.default.dropdown:not(.button)>input:focus~.text, .pageHeader  ::v-deep .ui.dropdown:not(.button)>input:focus~.default.text,.pageHeader ::v-deep .ui.active.search.dropdown input.search:focus+.text{
  color:#fff !important;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}


::v-deep .ui.selection.active.dropdown:hover,::v-deep .ui.selection.active.dropdown{
  box-shadow:none;
}

::v-deep .ui.dropdown .menu>.item:hover{
  color:#1dd8f6;
  background:#EAF9FF !important;
}
::v-deep .ui.dropdown .menu>.item.selected{
  color:#1dd8f6;
  background:#fff;
}
::v-deep #modal-1 .modal-dialog {
  max-width:850px;
}
</style>

<style lang="scss">
.ui.selection.dropdown.tenantList .text {
  color: #6a6a6a;
  left: -5px;
  z-index: 3;
  top: 1px;
}
.pageHeader .ui.selection.dropdown.tenantList .text {
  color: #fff;
  left: 0px;
  z-index: 3;
  top: 1px;
}

.pad-0 {
  padding: 0 !important;
}
.btn-primary.disabled, .btn-primary:disabled {
    color: #8E8E8E;
    background-color: #ebebeb;
    border-color: #ebebeb;
}

.play-checkbox {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
}


</style>
